import React from 'react';
import { observer } from 'mobx-react';
import { CheckboxInput, TextDefault } from '@awarego-ui/components';
import BounceReasonCell, {
    BounceKindCell,
    bounceReasonSort,
} from './BounceReasonCell';
import NameAndSublistCell from '../../../components/manager/NameAndSublistCell';
import { caseAndDiacriticsInsensitiveSort } from '../../../components/table/table-helpers';

function isRowSelected(store, email) {
    if (store.selection.allSelected) {
        return !store.selection.unChecked[email];
    }
    return !!store.selection.checked[email];
}

export function bouncedEmailColumns(store) {
    return [
        {
            Header: 'Name',
            id: 'name',
            accessor: (x) => {
                return x.name || x.email;
            },
            sortType: caseAndDiacriticsInsensitiveSort,
            Cell: observer((x) => {
                const email = x.row.original.email;
                return (
                    <CheckboxInput
                        label={x.value}
                        checked={isRowSelected(store, email)}
                        noYPadding={true}
                        onChange={(e) => {
                            store.selection.toggleRow(
                                x.row.original,
                                e.target.checked
                            );
                        }}
                    />
                );
            }),
        },
        {
            Header: 'List',
            accessor: 'lists_names',
            Cell: (x) => {
                if (x.value && x.value.length > 0) {
                    return (
                        <NameAndSublistCell
                            subListItems={x.value}
                            maxVisibleSubListCount={1}
                        ></NameAndSublistCell>
                    );
                }
                return <TextDefault lighter>List unavailable</TextDefault>;
            },
        },
        {
            Header: 'Email',
            accessor: 'email',
        },
        {
            Header: 'Bounce',
            accessor: 'bounceKind',
            Cell: (x) => <BounceKindCell value={x.value} />,
        },
        {
            Header: 'Code',
            accessor: 'code',
            Cell: (x) => x.value || '—',
        },
        {
            Header: 'Reason',
            accessor: 'reason',
            sortType: bounceReasonSort,
            Cell: (x) => <BounceReasonCell reason={x.value} />,
        },
    ];
}
